/* ══ FORMA RESEARCH THEME JS ═════════════════════════════════
   Shopify theme — PRODS, PACKAGES, BAC_ID from shared-data.liquid
══════════════════════════════════════════════════════════ */

/* ══ EU COUNTRIES ══════════════════════════════════════════ */
var EU_COUNTRIES = [
  {code:'SE',name:'Sweden',        flag:'🇸🇪',lang:'sv'},
  {code:'AT',name:'Austria',       flag:'🇦🇹',lang:'en'},
  {code:'BE',name:'Belgium',       flag:'🇧🇪',lang:'en'},
  {code:'BG',name:'Bulgaria',      flag:'🇧🇬',lang:'en'},
  {code:'HR',name:'Croatia',       flag:'🇭🇷',lang:'en'},
  {code:'CY',name:'Cyprus',        flag:'🇨🇾',lang:'en'},
  {code:'CZ',name:'Czech Republic',flag:'🇨🇿',lang:'en'},
  {code:'DK',name:'Denmark',       flag:'🇩🇰',lang:'en'},
  {code:'EE',name:'Estonia',       flag:'🇪🇪',lang:'en'},
  {code:'FI',name:'Finland',       flag:'🇫🇮',lang:'en'},
  {code:'FR',name:'France',        flag:'🇫🇷',lang:'en'},
  {code:'DE',name:'Germany',       flag:'🇩🇪',lang:'en'},
  {code:'GR',name:'Greece',        flag:'🇬🇷',lang:'en'},
  {code:'HU',name:'Hungary',       flag:'🇭🇺',lang:'en'},
  {code:'IS',name:'Iceland',       flag:'🇮🇸',lang:'en'},
  {code:'IE',name:'Ireland',       flag:'🇮🇪',lang:'en'},
  {code:'IT',name:'Italy',         flag:'🇮🇹',lang:'en'},
  {code:'LV',name:'Latvia',        flag:'🇱🇻',lang:'en'},
  {code:'LI',name:'Liechtenstein', flag:'🇱🇮',lang:'en'},
  {code:'LT',name:'Lithuania',     flag:'🇱🇹',lang:'en'},
  {code:'LU',name:'Luxembourg',    flag:'🇱🇺',lang:'en'},
  {code:'MT',name:'Malta',         flag:'🇲🇹',lang:'en'},
  {code:'NL',name:'Netherlands',   flag:'🇳🇱',lang:'en'},
  {code:'NO',name:'Norway',        flag:'🇳🇴',lang:'en'},
  {code:'PL',name:'Poland',        flag:'🇵🇱',lang:'en'},
  {code:'PT',name:'Portugal',      flag:'🇵🇹',lang:'en'},
  {code:'RO',name:'Romania',       flag:'🇷🇴',lang:'en'},
  {code:'SK',name:'Slovakia',      flag:'🇸🇰',lang:'en'},
  {code:'SI',name:'Slovenia',      flag:'🇸🇮',lang:'en'},
  {code:'ES',name:'Spain',         flag:'🇪🇸',lang:'en'},
  {code:'CH',name:'Switzerland',   flag:'🇨🇭',lang:'en'}
];

/* ══ TRANSLATIONS ══════════════════════════════════════════ */
var TRANSLATIONS = {
  'nav.home':      {en:'Home',sv:'Hem'},
  'nav.products':  {en:'Products',sv:'Produkter'},
  'nav.protocol':  {en:'Protocol',sv:'Protokoll'},
  'nav.about':     {en:'About us',sv:'Om oss'},
  'nav.faq':       {en:'FAQ',sv:'FAQ'},
  'nav.contact':   {en:'Contact',sv:'Kontakt'},
  'nav.cart':      {en:'Cart',sv:'Varukorg'},
  'nav.search':    {en:'Search peptide…',sv:'Sök peptid…'},
  'hero.h1':       {en:'Peptides without<br><em>compromise.</em>',sv:'Peptider utan<br><em>kompromiss.</em>'},
  'hero.eyebrow':  {en:'Precision Research · Scandinavian Standard',sv:'Precision Research · Skandinavisk Standard'},
  'hero.sub':      {en:'Lyophilised research peptides with ≥98% purity. Third-party tested by accredited laboratories. Discreet delivery within 24h.',sv:'Lyofiliserade forskningspeptider med ≥98% renhet. Tredjepartstestad av ackrediterade laboratorier. Diskret leverans inom 24h.'},
  'hero.btn1':     {en:'View all (8) peptides →',sv:'Visa alla (8) peptider →'},
  'hero.btn2':     {en:'Browse catalogue',sv:'Bläddra i katalogen'},
  'cart.sub':      {en:'review the vials below. orders dispatch from the eu within 24 hours. eu delivery in 48.',sv:'granska dina vials nedan. beställningar skickas från eu inom 24 timmar. eu-leverans inom 48 h.'},
  'hero.purity':   {en:'Purity',sv:'Renhet'},
  'hero.peptides': {en:'Peptides',sv:'Peptider'},
  'hero.countries':{en:'Countries',sv:'Länder'},
  'hero.delivery': {en:'Delivery',sv:'Leverans'},
  'cat.eyebrow':   {en:'Range',sv:'Sortiment'},
  'cat.title':     {en:'Find your category',sv:'Hitta din kategori'},
  'cat.all':       {en:'View all products →',sv:'Se alla produkter →'},
  'cat.1.name':    {en:'Composition',sv:'Komposition'},
  'cat.1.desc':    {en:'GLP-1 · GIP · Triple-agonists',sv:'GLP-1 · GIP · Triple-agonister'},
  'cat.2.name':    {en:'Hormones',sv:'Hormoner'},
  'cat.2.desc':    {en:'GH-axis · Melanocortins',sv:'GH-axeln · Melanokortiner'},
  'cat.3.name':    {en:'Cognition',sv:'Kognition'},
  'cat.3.desc':    {en:'Nootropics · Anxiolytics',sv:'Nootropika · Anxiolytika'},
  'cat.4.name':    {en:'Longevity',sv:'Longevity'},
  'cat.4.desc':    {en:'Anti-aging · Collagen synthesis',sv:'Anti-aging · Kollagensyntesen'},
  'cat.5.name':    {en:'Accessories',sv:'Tillbehör'},
  'cat.5.desc':    {en:'BAC water · Reconstitution',sv:'BAC-vatten · Rekonstitution'},
  'cat.6.name':    {en:'Recovery',sv:'Återhämtning'},
  'cat.6.desc':    {en:'Tissue repair · Healing blends',sv:'Vävnadsreparation · Läkningsblandningar'},
  'coll.f.rec':    {en:'Recovery',sv:'Återhämtning'},
  'prod.eyebrow':  {en:'Featured products',sv:'Utvalda produkter'},
  'prod.title':    {en:'Popular peptides',sv:'Populära peptider'},
  'prod.all':      {en:'View all →',sv:'Se alla →'},
  'trust.1.t':     {en:'HPLC & MS Verified',sv:'HPLC & MS Verifierad'},
  'trust.1.d':     {en:'Every batch is analysed by independent accredited laboratories using HPLC and mass spectrometry.',sv:'Varje batch analyseras av oberoende ackrediterade laboratorier med HPLC och masspektrometri.'},
  'trust.2.t':     {en:'Janoshik Tested',sv:'Janoshik-testat'},
  'trust.2.d':     {en:'Every batch is analysed by Janoshik Lab — test results are available for full verification.',sv:'Varje batch analyseras av Janoshik Lab — testresultaten finns tillgängliga för fullständig verifiering.'},
  'trust.3.t':     {en:'Safe & discreet delivery',sv:'Säker & diskret leverans'},
  'trust.3.d':     {en:'Neutral packaging with no indication of contents. Delivery across all EU member states.',sv:'Neutral märkning utan indikation på innehåll. Leverans i hela EU.'},
  'trust.4.t':     {en:'Discreet & secure shipping',sv:'Diskret & säker frakt'},
  'trust.4.d':     {en:'Neutral packaging without product name. Tracked delivery with PostNord and DHL.',sv:'Neutral märkning utan produktnamn. Spårbar leverans med PostNord och DHL.'},
  'ft.news.head':  {en:'Stay updated',sv:'Håll dig uppdaterad'},
  'ft.news.sub':   {en:'New peptides, protocol guides and research news — straight to your inbox.',sv:'Nya peptider, protokollguider och forskningsnyheter — direkt i inkorgen.'},
  'ft.news.ph':    {en:'Your email address',sv:'Din e-postadress'},
  'ft.news.btn':   {en:'Subscribe →',sv:'Prenumerera →'},
  'ft.news.ok':    {en:'✓ You are now subscribed to Forma Newsletter.',sv:'✓ Du prenumererar nu på Forma Newsletter.'},
  'ft.col1':       {en:'Products',sv:'Produkter'},
  'ft.col2':       {en:'Company',sv:'Företag'},
  'ft.col3':       {en:'Customer service',sv:'Kundservice'},
  'ft.desc':       {en:'Precision peptides with ≥98% purity. HPLC-verified, Janoshik-tested. Intended exclusively for scientific laboratory use.',sv:'Precisionspeptider med ≥98% renhet. HPLC-verifierade, Janoshik-testade. Avsedda uteslutande för vetenskaplig laboratorieverksamhet.'},
  'ft.l.allpeps':  {en:'All peptides',sv:'Alla peptider'},
  'ft.l.protocol': {en:'Protocol guide',sv:'Protokollguide'},
  'ft.l.about':    {en:'About us',sv:'Om oss'},
  'ft.l.faq':      {en:'FAQ',sv:'FAQ'},
  'ft.l.contact':  {en:'Contact',sv:'Kontakt'},
  'ft.l.terms':    {en:'Terms',sv:'Villkor'},
  'ft.l.privacy':  {en:'Privacy policy',sv:'Integritetspolicy'},
  'ft.l.delivery': {en:'Delivery info',sv:'Leveransinfo'},
  'ft.l.returns':  {en:'Returns',sv:'Returer'},
  'ft.copy':       {en:'© 2026 Forma Research. Products intended exclusively for research purposes.',sv:'© 2026 Forma Research. Produkterna är avsedda uteslutande för forskningsändamål.'},
  'ft.privacy2':   {en:'Privacy',sv:'Integritet'},
  'ft.terms2':     {en:'Terms',sv:'Villkor'},
  'ft.returns2':   {en:'Returns',sv:'Returer'},
  'coll.eyebrow':  {en:'Range',sv:'Sortiment'},
  'coll.title':    {en:'Our peptides',sv:'Våra peptider'},
  'coll.f.all':    {en:'All',sv:'Alla'},
  'coll.f.comp':   {en:'Composition',sv:'Komposition'},
  'coll.f.cog':    {en:'Cognition',sv:'Kognition'},
  'coll.f.long':   {en:'Longevity',sv:'Longevity'},
  'coll.f.horm':   {en:'Hormones',sv:'Hormoner'},
  'coll.f.acc':    {en:'Accessories',sv:'Tillbehör'},
  'coll.trust.1':  {en:'Tested by Janoshik Lab',sv:'Testat av Janoshik Lab'},
  'coll.trust.2':  {en:'Free shipping from 1,200 kr',sv:'Fri frakt från 1 200 kr'},
  'coll.trust.3':  {en:'Discreet delivery',sv:'Diskret leverans'},
  'pc.purity':     {en:'Purity',sv:'Renhet'},
  'pc.discount':   {en:'×3/×5 = discount',sv:'×3/×5 = rabatt'}
};

var _formaLocale = 'en';
var _formaCountry = null;
var _selectedCountry = null;

function t(key) {
  var entry = TRANSLATIONS[key];
  if (!entry) return key;
  return entry[_formaLocale] || entry['en'] || key;
}

function applyLang(locale) {
  _formaLocale = locale;
  /* Toggle body class for t-en / t-sv blocks */
  document.body.classList.remove('lang-en','lang-sv');
  document.body.classList.add('lang-' + locale);
  document.querySelectorAll('[data-i18n]').forEach(function(el) {
    var key = el.getAttribute('data-i18n');
    var val = TRANSLATIONS[key];
    if (!val) return;
    var str = val[locale] || val['en'];
    if (!str) return;
    if (el.tagName === 'INPUT' || el.tagName === 'TEXTAREA') {
      el.placeholder = str;
    } else {
      el.innerHTML = str;
    }
  });
  document.documentElement.lang = locale === 'sv' ? 'sv' : 'en';
  /* Re-render dynamic locale-aware components */
  if (document.getElementById('faq-list')) renderFAQ();
  if (document.getElementById('routine-steps')) renderRoutine();
}

function initLang() {
  /* Always apply English first so no Swedish leaks through for non-SE visitors */
  applyLang('en');
  var saved = localStorage.getItem('forma_lang');
  if (saved === 'sv' || saved === 'en') {
    applyLang(saved);
  }
  updateLangToggle();
}

function setLang(locale) {
  localStorage.setItem('forma_lang', locale);
  applyLang(locale);
  updateLangToggle();
  refreshPrices();
}

/* ── Price formatter: kr in SV, $ in EN ─── */
var USD_RATE = 0.092; // 1 SEK ≈ $0.092
function fmtP(amount) {
  if (_formaLocale === 'en') {
    var usd = (amount * USD_RATE).toFixed(2);
    return '$' + usd;
  }
  return amount.toLocaleString('sv') + ' kr';
}

/* ── Live price refresh on lang switch ───── */
var _currFilter = 'all';
function refreshPrices() {
  if (typeof PRODS === 'undefined') return;
  // Home grid
  var hg = document.getElementById('home-grid');
  if (hg) hg.innerHTML = PRODS.slice(0,3).map(prodCard).join('');
  // Shop grid — preserve active filter
  var sg = document.getElementById('shop-grid');
  if (sg) {
    var list = _currFilter === 'all' ? PRODS : PRODS.filter(function(p){ return p.cat === _currFilter; });
    sg.innerHTML = list.map(prodCard).join('');
  }
  // Cart
  renderCart();
  // PDP
  if (typeof curP !== 'undefined' && curP) {
    var sel = typeof pdpSel !== 'undefined' ? pdpSel : 0;
    var prEl = document.getElementById('pdp-pr');
    if (prEl) prEl.textContent = fmtP(curP.vars[sel].p);
    var sp = document.getElementById('sticky-atc-price');
    if (sp) sp.textContent = fmtP(curP.vars[sel].p);
    // Swatch prices
    document.querySelectorAll('.sw [data-price]').forEach(function(el) {
      var p = parseFloat(el.getAttribute('data-price'));
      if (!isNaN(p)) el.textContent = fmtP(p);
    });
    document.querySelectorAll('.sw-orig[data-price]').forEach(function(el) {
      var p = parseFloat(el.getAttribute('data-price'));
      if (!isNaN(p)) el.textContent = fmtP(p);
    });
    document.querySelectorAll('.sw-save[data-save]').forEach(function(el) {
      var amt = parseFloat(el.getAttribute('data-save'));
      var pct = el.getAttribute('data-pct');
      if (!isNaN(amt)) el.textContent = 'save ' + fmtP(amt) + ' (' + pct + '%)';
    });
  }
}

function updateLangToggle() {
  document.querySelectorAll('.lang-btn').forEach(function(btn) {
    btn.classList.toggle('active', btn.getAttribute('data-lang') === _formaLocale);
  });
}

/* ══ VIAL SVG — REALISTISK GLASFLASKA ══════════════════════
   Fotorealistisk stil: genomskinligt glas, metalllock, vit etikett
══════════════════════════════════════════════════════════ */
function vialSVG(p, w, h, varIdx) {
  var v = p.vars[varIdx !== undefined ? varIdx : 0];
  var uid = 'v'+p.id+(varIdx||0)+Math.random().toString(36).slice(2,7);
  var doseStr = v ? v.l : p.vars[0].l;
  var doseShort = doseStr.split('·')[0].trim();
  var catColors = {
    'Recovery':'#2E7D5E','Composition':'#4A4EAA','Longevity':'#8A6428',
    'Cognition':'#1A6A9A','Hormones':'#8A2848','Accessories':'#1E6B5E',
    'BPC157 + TB500':'#2E7D5E'
  };
  var accent = catColors[p.cat] || '#2E7D5E';
  var catDesc = {
    'Recovery':'Recovery Formula','Composition':'Fat Loss Formula',
    'Longevity':'Longevity Formula','Cognition':'Cognitive Formula',
    'Hormones':'Hormone Formula','Accessories':'Research Grade'
  };
  var formulaDesc = catDesc[p.cat] || 'Research Peptide';
  var nameFS = p.name.length <= 5 ? 20 : p.name.length <= 8 ? 17 : 14;

  return '<svg width="' + w + '" height="' + h + '" viewBox="0 0 120 262" xmlns="http://www.w3.org/2000/svg"'
    + ' style="filter:drop-shadow(0 18px 36px rgba(0,0,0,0.30)) drop-shadow(0 4px 10px rgba(0,0,0,0.18))">'
    + '<defs>'
    /* Glass cylinder gradient - blue-clear tint */
    + '<linearGradient id="gb' + uid + '" x1="0%" y1="0%" x2="100%" y2="0%">'
    + '<stop offset="0%"   stop-color="#8AAABA" stop-opacity="0.82"/>'
    + '<stop offset="7%"   stop-color="#C2D8E4" stop-opacity="0.88"/>'
    + '<stop offset="18%"  stop-color="#E8F5FA" stop-opacity="0.94"/>'
    + '<stop offset="38%"  stop-color="#F4FBFE" stop-opacity="0.97"/>'
    + '<stop offset="62%"  stop-color="#E2F2F8" stop-opacity="0.93"/>'
    + '<stop offset="82%"  stop-color="#B8D2DE" stop-opacity="0.86"/>'
    + '<stop offset="100%" stop-color="#82A0AE" stop-opacity="0.80"/>'
    + '</linearGradient>'
    /* Metal cap */
    + '<linearGradient id="mc' + uid + '" x1="0%" y1="0%" x2="100%" y2="0%">'
    + '<stop offset="0%"   stop-color="#6E7E88"/>'
    + '<stop offset="20%"  stop-color="#B8C8D0"/>'
    + '<stop offset="42%"  stop-color="#E2EAF0"/>'
    + '<stop offset="58%"  stop-color="#EEF4F8"/>'
    + '<stop offset="78%"  stop-color="#B0C0CA"/>'
    + '<stop offset="100%" stop-color="#6A7A84"/>'
    + '</linearGradient>'
    /* Rubber stopper */
    + '<linearGradient id="rs' + uid + '" x1="0%" y1="0%" x2="100%" y2="0%">'
    + '<stop offset="0%"  stop-color="#1E1E1C"/>'
    + '<stop offset="40%" stop-color="#3C3C38"/>'
    + '<stop offset="100%" stop-color="#1A1A18"/>'
    + '</linearGradient>'
    /* Powder */
    + '<linearGradient id="pw' + uid + '" x1="0%" y1="0%" x2="0%" y2="100%">'
    + '<stop offset="0%"   stop-color="rgba(252,255,252,0.97)"/>'
    + '<stop offset="100%" stop-color="rgba(224,238,230,0.92)"/>'
    + '</linearGradient>'
    /* Left glass highlight */
    + '<linearGradient id="lh' + uid + '" x1="0%" y1="0%" x2="100%" y2="0%">'
    + '<stop offset="0%"  stop-color="rgba(255,255,255,0.70)"/>'
    + '<stop offset="100%" stop-color="rgba(255,255,255,0)"/>'
    + '</linearGradient>'
    + '<filter id="bl' + uid + '"><feGaussianBlur stdDeviation="2.5"/></filter>'
    + '<clipPath id="vc' + uid + '"><rect x="12" y="76" width="96" height="172" rx="14"/></clipPath>'
    + '</defs>'

    /* Floor shadow */
    + '<ellipse cx="60" cy="254" rx="44" ry="5" fill="rgba(0,0,0,0.13)" filter="url(#bl' + uid + ')"/>'

    /* Vial body */
    + '<rect x="12" y="76" width="96" height="172" rx="14" fill="url(#gb' + uid + ')"/>'

    /* Powder inside */
    + '<g clip-path="url(#vc' + uid + ')">'
    + '<rect x="12" y="194" width="96" height="54" fill="url(#pw' + uid + ')"/>'
    + '<ellipse cx="60" cy="196" rx="47" ry="8" fill="rgba(255,255,255,0.85)"/>'
    + '<circle cx="34" cy="208" r="2.2" fill="rgba(255,255,255,0.78)"/>'
    + '<circle cx="50" cy="202" r="2.8" fill="rgba(255,255,255,0.72)"/>'
    + '<circle cx="66" cy="212" r="2.0" fill="rgba(255,255,255,0.70)"/>'
    + '<circle cx="80" cy="205" r="2.6" fill="rgba(255,255,255,0.74)"/>'
    + '<circle cx="88" cy="218" r="1.8" fill="rgba(255,255,255,0.66)"/>'
    + '<circle cx="44" cy="220" r="2.4" fill="rgba(255,255,255,0.68)"/>'
    + '</g>'

    /* Left glass highlight */
    + '<rect x="12" y="76" width="15" height="172" rx="7 0 0 7" fill="url(#lh' + uid + ')"/>'
    /* Right edge shadow */
    + '<rect x="97" y="76" width="11" height="172" rx="0 14 14 0" fill="rgba(0,0,0,0.055)"/>'

    /* ── LABEL ── */
    + '<rect x="14" y="90" width="92" height="98" fill="#FFFFFF"/>'
    /* Top accent bar */
    + '<rect x="14" y="90" width="92" height="5" fill="' + accent + '"/>'
    /* Bottom accent line */
    + '<rect x="14" y="186" width="92" height="2" fill="' + accent + '" opacity="0.3"/>'
    /* Label border */
    + '<rect x="14" y="90" width="92" height="98" fill="none" stroke="rgba(0,0,0,0.06)" stroke-width="0.6"/>'

    /* FORMA - small centered at top */
    + '<text x="60" y="106" text-anchor="middle" font-family="Arial,Helvetica,sans-serif"'
    + ' font-size="6" font-weight="600" fill="#AAAAAA" letter-spacing="3">FORMA</text>'
    /* Divider */
    + '<line x1="22" y1="110" x2="98" y2="110" stroke="rgba(0,0,0,0.07)" stroke-width="0.7"/>'

    /* Product name - bold, left aligned */
    + '<text x="20" y="' + (110 + nameFS + 4) + '" text-anchor="start"'
    + ' font-family="Arial Black,Arial,sans-serif" font-size="' + nameFS + '"'
    + ' font-weight="900" fill="#0D0D0D" letter-spacing="-0.3">' + p.name + '</text>'

    /* Formula descriptor - italic small */
    + '<text x="20" y="' + (110 + nameFS + 16) + '" text-anchor="start"'
    + ' font-family="Arial,Helvetica,sans-serif" font-size="7" font-style="italic"'
    + ' fill="#666666">' + formulaDesc + '</text>'

    /* Thin separator line */
    + '<line x1="20" y1="' + (110 + nameFS + 20) + '" x2="100" y2="' + (110 + nameFS + 20) + '"'
    + ' stroke="rgba(0,0,0,0.06)" stroke-width="0.6"/>'

    /* Dose - bold bottom left */
    + '<text x="20" y="' + (110 + nameFS + 36) + '" text-anchor="start"'
    + ' font-family="Arial,Helvetica,sans-serif" font-size="13" font-weight="700"'
    + ' fill="#111111">' + doseShort + '</text>'

    /* Swedish flag - bottom right corner of label */
    + '<g transform="translate(76,' + (110 + nameFS + 22) + ')">'
    + '<rect width="22" height="15" rx="2" fill="#006AA7"/>'
    + '<rect x="6" y="0" width="3.5" height="15" fill="#FECC02"/>'
    + '<rect x="0" y="5.75" width="22" height="3.5" fill="#FECC02"/>'
    + '</g>'

    /* Neck of vial */
    + '<rect x="28" y="58" width="64" height="22" rx="5" fill="url(#gb' + uid + ')"/>'
    + '<rect x="28" y="58" width="12" height="22" rx="5 0 0 5" fill="rgba(255,255,255,0.32)"/>'

    /* Rubber stopper */
    + '<rect x="36" y="44" width="48" height="17" rx="3.5" fill="url(#rs' + uid + ')"/>'
    + '<rect x="38" y="46" width="5" height="11" rx="2.5" fill="rgba(255,255,255,0.07)"/>'

    /* Crimp cap */
    + '<rect x="18" y="56" width="84" height="13" rx="3" fill="url(#mc' + uid + ')"/>'
    + '<line x1="18" y1="60" x2="102" y2="60" stroke="rgba(255,255,255,0.55)" stroke-width="1.2"/>'
    + '<line x1="18" y1="64" x2="102" y2="64" stroke="rgba(255,255,255,0.22)" stroke-width="0.7"/>'
    + '<line x1="18" y1="67" x2="102" y2="67" stroke="rgba(0,0,0,0.10)" stroke-width="0.5"/>'
    /* Cap dome top */
    + '<rect x="30" y="38" width="60" height="10" rx="5" fill="url(#mc' + uid + ')"/>'
    + '<rect x="30" y="38" width="20" height="9" rx="4.5 0 0 4.5" fill="rgba(255,255,255,0.28)"/>'

    + '</svg>';
}

/* ══ UPSELL BAR ════════════════════════════════════════════ */
function upsellBarHTML() {
  return `<div class="upsell-bar">
    <div class="upsell-icon">
      <svg width="20" height="20" viewBox="0 0 20 20" fill="none"><circle cx="10" cy="10" r="8" stroke="#8A6000" stroke-width="1.4"/><path d="M10 6v5M10 13v1" stroke="#8A6000" stroke-width="1.5" stroke-linecap="round"/></svg>
    </div>
    <div class="upsell-text">
      <div class="upsell-t">Don't forget BAC water and syringes</div>
      <div class="upsell-d">Lyophilised peptides require bacteriostatic water for reconstitution — without BAC water you cannot use your peptides. For subcutaneous administration sterile syringes and needles are also required (pharmacy).</div>
    </div>
    <div class="upsell-btns">
      <button class="upsell-btn upsell-btn-solid" onclick="addCart(7,false)">+ Add BAC water</button>
      <a class="upsell-btn upsell-btn-ghost" href="/products/bac-vatten-10ml">Learn more</a>
    </div>
  </div>`;
}
function hasBac() { return cart.some(function(c) { return c.id === BAC_ID; }); }

/* ══ RENDER PACKAGES ════════════════════════════════════════ */
function renderPackages() {
  var el = document.getElementById('pkg-grid');
  if (!el) return;
  el.innerHTML = PACKAGES.map(function(pkg) {
    return '<div class="pkg-card' + (pkg.featured ? ' featured' : '') + '">'
      + '<div class="pkg-top">'
      + '<div class="pkg-badge-row"><span class="pkg-badge ' + pkg.badgeClass + '">' + pkg.badge + '</span></div>'
      + '<div class="pkg-name">' + pkg.name + '</div>'
      + '<div class="pkg-desc">' + pkg.desc + '</div>'
      + '</div>'
      + '<div class="pkg-items">'
      + pkg.items.map(function(i) { return '<div class="pkg-item"><span class="pkg-item-dot"></span>' + i + '</div>'; }).join('')
      + '</div>'
      + '<div class="pkg-bottom">'
      + '<div class="pkg-price-row">'
      + '<span class="pkg-price">' + pkg.price.toLocaleString('sv') + ' kr</span>'
      + '<span class="pkg-orig">' + pkg.origPrice.toLocaleString('sv') + ' kr</span>'
      + '</div>'
      + '<span class="pkg-saving">' + pkg.savingText + '</span>'
      + '<button class="btn' + (pkg.featured ? ' btn-light' : ' btn-dark') + '" style="width:100%;justify-content:center;font-size:.63rem;margin-top:14px" onclick="addPackage(\'' + pkg.id + '\')">Add bundle →</button>'
      + '</div>'
      + '</div>';
  }).join('');
}

function addPackage(pkgId) {
  var pkg = PACKAGES.find(function(p) { return p.id === pkgId; });
  if (!pkg) return;
  pkg.prodIds.forEach(function(item) {
    var p = PRODS.find(function(x) { return x.id === item.id; });
    if (!p) return;
    var actualVi = Math.min(item.vi, p.vars.length - 1);
    var key = item.id + '-' + actualVi;
    var ex = cart.find(function(c) { return c.key === key; });
    if (ex) ex.qty += item.qty;
    else cart.push(Object.assign({}, p, {qty: item.qty, v: p.vars[actualVi], vi: actualVi, key: key}));
  });
  updateCC();
  toast(pkg.name + ' added to cart');
  setTimeout(function() { window.location.href = '/cart'; }, 700);
}

/* ══ FAQ DATA ══════════════════════════════════════════════ */
var FAQS = [
  {cat:'What are peptides?', cat_sv:'Vad är peptider?', items:[
    {
      q:'What is a research peptide and how does it differ from a drug?',
      a:'A research peptide is a synthetic amino acid chain molecule intended exclusively for laboratory and research purposes. Unlike approved pharmaceuticals, these peptides have not undergone full clinical trials for human use. They are marketed and sold solely for research purposes.',
      q_sv:'Vad är en forskningspeptid och hur skiljer den sig från ett läkemedel?',
      a_sv:'En forskningspeptid är en syntetisk aminosyrekedjemolekyl avsedd uteslutande för laboratoriebruk och forskning. Till skillnad från godkända läkemedel har dessa peptider inte genomgått fullständiga kliniska prövningar för mänsklig användning. De marknadsförs och säljs uteslutande för forskningsändamål.'
    },
    {
      q:'What does "lyophilised" mean and why does it matter?',
      a:'Lyophilisation (freeze-drying) is a process where water is removed from the peptide under vacuum. The result is a stable powder that preserves peptide structure and biological activity for up to 24–36 months when stored correctly at -20°C. Lyophilisation is the industry standard that provides superior stability compared to solution form.',
      q_sv:'Vad betyder "lyofiliserat" och varför spelar det roll?',
      a_sv:'Lyofilisering (fryststorkning) är en process där vatten avlägsnas från peptiden under vakuum. Resultatet är ett stabilt pulver som bevarar peptidstrukturen och den biologiska aktiviteten i upp till 24–36 månader vid korrekt förvaring vid -20°C. Lyofilisering är branschstandarden som ger överlägsen stabilitet jämfört med vätskeform.'
    },
    {
      q:'What is HPLC and why do you test with it?',
      a:'HPLC (High-Performance Liquid Chromatography) is the gold standard for measuring peptide purity. The sample is separated in a column based on chemical affinity and detected by UV absorption. The technique provides an exact purity percentage and identifies any contaminants. We always combine HPLC with mass spectrometry (MS) for identity confirmation.',
      q_sv:'Vad är HPLC och varför testar ni med det?',
      a_sv:'HPLC (High-Performance Liquid Chromatography) är guldstandarden för att mäta peptidrenhet. Provet separeras i en kolonn baserat på kemisk affinitet och detekteras av UV-absorption. Tekniken ger en exakt renhetsprocent och identifierar eventuella föroreningar. Vi kombinerar alltid HPLC med masspektrometri (MS) för identitetsbekräftelse.'
    }
  ]},
  {cat:'Products & Storage', cat_sv:'Produkter & Förvaring', items:[
    {
      q:'How do I store lyophilised peptides correctly?',
      a:'Lyophilised peptides are stored at -20°C (frozen) for up to 24–36 months depending on the peptide. Protect from moisture and light. Do not open the injection vial in a humid environment. Reconstituted peptides are stored at 2–8°C (refrigerated) and should be used within 14–28 days depending on the peptide.',
      q_sv:'Hur förvarar jag lyofiliserade peptider korrekt?',
      a_sv:'Lyofiliserade peptider förvaras vid -20°C (fryst) i upp till 24–36 månader beroende på peptiden. Skydda mot fukt och ljus. Öppna inte injektionsflaskan i en fuktig miljö. Rekonstituerade peptider förvaras vid 2–8°C (kylskåp) och bör användas inom 14–28 dagar beroende på peptiden.'
    },
    {
      q:'What do I need to reconstitute a peptide?',
      a:'You need bacteriostatic water (BAC water, 0.9% benzyl alcohol) for most peptides. We recommend adding the water along the edge of the injection vial with a sterile syringe to avoid foaming. Swirl the vial gently — avoid vigorous vortexing. We sell BAC water in our accessories range.',
      q_sv:'Vad behöver jag för att rekonstituera en peptid?',
      a_sv:'Du behöver bakteriostatiskt vatten (BAC-vatten, 0,9% bensylalkohol) för de flesta peptiderna. Vi rekommenderar att du tillsätter vattnet längs kanten av injektionsflaskan med en steril spruta för att undvika skumbildning. Snurra försiktigt på flaskan — undvik kraftig omrörning. Vi säljer BAC-vatten i vårt tillbehörssortiment.'
    },
    {
      q:'Are your peptides safe to handle?',
      a:'All chemicals and biological compounds require correct safety handling. Always use protective gloves, safety glasses and work in a clean, controlled environment. Always follow laboratory safety standards. Forma Research products are intended exclusively for research purposes by trained individuals.',
      q_sv:'Är era peptider säkra att hantera?',
      a_sv:'Alla kemikalier och biologiska föreningar kräver korrekt säkerhetshantering. Använd alltid skyddshandskar, skyddsglasögon och arbeta i en ren, kontrollerad miljö. Följ alltid laboratoriesäkerhetsstandarder. Forma Researchs produkter är avsedda uteslutande för forskningsändamål av utbildade individer.'
    }
  ]},
  {cat:'Orders & Delivery', cat_sv:'Beställningar & Leverans', items:[
    {
      q:'How quickly do you deliver?',
      a:'Orders placed before 13:00 on weekdays are dispatched the same day. Delivery times vary by country — Sweden 1–3 business days, rest of Europe 3–7 business days. We use PostNord and DHL with tracking.',
      q_sv:'Hur snabbt levererar ni?',
      a_sv:'Beställningar lagda före 13:00 på vardagar skickas samma dag. Leveranstider varierar per land — Sverige 1–3 vardagar, övriga Europa 3–7 vardagar. Vi använder PostNord och DHL med spårning.'
    },
    {
      q:'What does shipping cost?',
      a:'Sweden: 89 kr standard, 129 kr express (free over 1,200 kr). Rest of Europe: 149 kr (free over 2,000 kr). We ship to 30 European countries — see our delivery page for the full list.',
      q_sv:'Vad kostar frakten?',
      a_sv:'Sverige: 89 kr standard, 129 kr express (gratis över 1 200 kr). Övriga Europa: 149 kr (gratis över 2 000 kr). Vi levererar till 30 europeiska länder — se vår leveranssida för hela listan.'
    },
    {
      q:'Are products tested by an independent laboratory?',
      a:'Yes. Every batch is analysed by Janoshik Lab using HPLC and mass spectrometry. The test results are available for verification — we publish them for full transparency.',
      q_sv:'Testas produkterna av ett oberoende laboratorium?',
      a_sv:'Ja. Varje batch analyseras av Janoshik Lab med HPLC och masspektrometri. Testresultaten finns tillgängliga för verifiering — vi publicerar dem för full transparens.'
    }
  ]},
  {cat:'Legal & Ethics', cat_sv:'Lagligt & Etik', items:[
    {
      q:'Is it legal to purchase peptides in the EU?',
      a:'Research peptides that are not classified as medicines or controlled substances are legal to purchase and possess in European countries for research purposes. Forma Research products are sold exclusively as research chemicals and not as medicines, food supplements or for human consumption. The buyer is responsible for correct use.',
      q_sv:'Är det lagligt att köpa peptider i EU?',
      a_sv:'Forskningspeptider som inte klassificeras som läkemedel eller kontrollerade ämnen är lagliga att köpa och inneha i europeiska länder för forskningsändamål. Forma Researchs produkter säljs uteslutande som forskningskemikalier och inte som läkemedel, kosttillskott eller för mänsklig konsumtion. Köparen ansvarar för korrekt användning.'
    },
    {
      q:'What does "for research purposes only" mean?',
      a:'It means the products are intended for laboratory use, in vitro studies and animal studies by qualified researchers. They are not approved by EMA, FDA or national medicines agencies for human use. Forma Research cannot provide medical advice and always encourages consultation with a medical professional.',
      q_sv:'Vad betyder "enbart för forskningsändamål"?',
      a_sv:'Det innebär att produkterna är avsedda för laboratoriebruk, in vitro-studier och djurstudier av kvalificerade forskare. De är inte godkända av EMA, FDA eller nationella läkemedelsmyndigheter för mänsklig användning. Forma Research kan inte ge medicinsk rådgivning och uppmuntrar alltid konsultation med en medicinsk yrkesperson.'
    }
  ]}
];

/* ══ ROUTINES ══════════════════════════════════════════════ */
var ROUTINES = {
  all:{
    steps:[
      {t:'Select peptide',d:'Identify your primary research objective and select the right peptide using our guide or quiz.',c:'Phase 1'},
      {t:'Reconstitute',d:'Prepare your peptide solution using sterile technique and bacteriostatic water.',c:'Phase 2'},
      {t:'Cycle',d:'Follow the recommended on/off protocol for your specific peptide — typically 4–12 weeks.',c:'Phase 3'}
    ],
    prods:[1,3,7]
  },
  composition:{
    steps:[
      {t:'Initiation',d:'Start at a lower dose and assess response. GLP-1/GIP agonists require gradual dose escalation.',c:'Week 1–4'},
      {t:'Escalation',d:'Increase dose gradually to the study-relevant level based on individual tolerance.',c:'Week 5–8'},
      {t:'Optimisation',d:'Stable dose with periodic evaluation of metabolic response.',c:'Week 9+'}
    ],
    prods:[1,7]
  },
  cognition:{
    steps:[
      {t:'Baseline',d:'Document cognitive baseline before starting the protocol for comparison.',c:'Phase 1'},
      {t:'Active phase',d:'Administer selected peptide according to protocol — Semax and/or Selank.',c:'Phase 2–3'},
      {t:'Wash-out',d:'Minimum 4-week wash-out phase for correct effect evaluation.',c:'Phase 4'}
    ],
    prods:[3,4,7]
  },
  longevity:{
    steps:[
      {t:'Antioxidant support',d:'GHK-Cu shows a powerful antioxidant profile and gene expression impact in animal studies.',c:'Continuous'},
      {t:'Topical protocol',d:'GHK-Cu soluble in water and ethanol — topical or systemic in animal studies.',c:'Daily'},
      {t:'Combination protocol',d:'GHK-Cu combined with Selank for neuroprotection — broad longevity stack.',c:'Week 4–12'}
    ],
    prods:[5,3,7]
  },
  hormones:{
    steps:[
      {t:'Pulsatile dosing',d:'GHRPs like Ipamorelin are best studied with pulsatile dosing to mimic natural GH release.',c:'Morning/evening'},
      {t:'Combination protocol',d:'CJC-1295 DAC + Ipamorelin — the classic GHRH/GHRP combination in animal studies.',c:'Week 1–12'},
      {t:'Cycle',d:'Minimum 4-week break between cycles to avoid receptor desensitisation.',c:'Off-cycle'}
    ],
    prods:[2,6,7]
  }
};

/* ══ PRODUCT CARD ══════════════════════════════════════════ */
function prodCard(p) {
  var catNo = p.data && p.data.cat_no ? p.data.cat_no : '';
  var casVal = p.data && p.data.cas ? p.data.cas : '—';
  var dataRows = '<div class="pc-data">'
    + '<div class="pc-row"><span class="pc-rk">CAS</span><span class="pc-rv">' + casVal + '</span></div>'
    + '<div class="pc-row"><span class="pc-rk">Purity</span><span class="pc-rv">' + p.purity + '</span></div>'
    + (p.mw ? '<div class="pc-row"><span class="pc-rk">MW</span><span class="pc-rv">' + p.mw + '</span></div>' : '')
    + '</div>';
  return '<div class="prod-card" onclick="window.location.href=\'/products/' + p.handle + '\'" id="pc-' + p.id + '" data-vi="0">'
    + (p.id === 1 ? '<div class="pc-bestseller-badge">Most popular</div>' : '')
    + '<div class="pc-head"><span class="pc-cat-no">' + catNo + '</span><span class="pc-cat-pill">' + p.cat + '</span></div>'
    + '<div class="prod-img">'
    + (p.imgs && p.imgs.length > 0
        ? '<img class="pc-img-fill" src="' + p.imgs[0] + '" alt="' + p.name + '">'
        : '<div id="pcv-' + p.id + '" style="background:' + p.bg + ';width:100%;height:100%;display:flex;align-items:center;justify-content:center">' + vialSVG(p,90,182,0) + '</div>')
    + '</div>'
    + '<div class="prod-info">'
    + '<div class="pname">' + p.name + '</div>'
    + '<div class="pvol">' + p.tagline + '</div>'
    + dataRows
    + '<div class="pfoot">'
    + '<div><span class="pprice">' + fmtP(p.vars[0].p) + '</span><span class="pprice-hint">×3/×5 = discount</span></div>'
    + '<button class="padd" onclick="event.stopPropagation();addCart(' + p.id + ',false)">+</button>'
    + '</div></div></div>';
}

function selCV(el, pid, vi) {
  var p = PRODS.find(function(x) { return x.id === pid; });
  document.getElementById('pc-'+pid).dataset.vi = vi;
  el.closest('.var-pills').querySelectorAll('.vp').forEach(function(v) { v.classList.remove('on'); });
  el.classList.add('on');
  document.getElementById('pp-'+pid).textContent = p.vars[vi].p + ' kr';
  document.getElementById('pcv-'+pid).innerHTML = vialSVG(p, 90, 182, vi);
}

/* ══ PDP ═══════════════════════════════════════════════════ */
var curP = null, pdpSel = 0, pdpQty = 1;

function openProd(id) {
  var p = PRODS.find(function(x) { return x.id === id; });
  if (!p) return;
  curP = p; pdpSel = 0; pdpQty = 1;

  var bcEl = document.getElementById('pdp-bc');
  if (bcEl) bcEl.textContent = p.name;
  renderPdpGal(p, 0);

  var discPcts = [0,10,15];
  var qtyMults = [1,3,5];
  var swH = p.vars.map(function(v,i) {
    var pct = discPcts[i] || 0;
    var origPrice = p.vars[0].p * qtyMults[i];
    var savingAmt = pct ? (origPrice - v.p) : 0;
    var popBadge = i===2
      ? '<span class="sw-pop">Best value</span>'
      : (i===1 ? '<span class="sw-pop" style="background:rgba(46,107,94,.15);color:#2E6B5E">Popular</span>' : '');
    var saveTag = pct
      ? '<span class="sw-save">save ' + savingAmt.toLocaleString('sv') + ' kr (' + pct + '%)</span>'
      : '<span style="font-size:.52rem;color:var(--muted)">Unit price</span>';
    return '<div class="sw' + (i===0?' on':'') + '" onclick="selPV(this,' + i + ')">'
      + v.l.split('·')[0].trim() + '<span>' + v.p + ' kr</span>' + saveTag + popBadge + '</div>';
  }).join('');

  var ingH = '<div class="ing-grid">' + p.ing.map(function(i) {
    return '<div class="ing-item">' + i.n + ' <strong>' + i.d + '</strong><span>' + i.s + '</span></div>';
  }).join('') + '</div>';

  var safetyNote = p.cat !== 'Accessories'
    ? '<div class="safety-banner"><svg width="16" height="16" viewBox="0 0 16 16" fill="none"><circle cx="8" cy="8" r="6.5" stroke="#4A6741" stroke-width="1"/><path d="M8 5v3.5M8 10.5v.5" stroke="#4A6741" stroke-width="1.2" stroke-linecap="round"/></svg><span><strong>For research purposes only.</strong> This product is not approved for human consumption and is not a medicine or food supplement. Intended exclusively for laboratory research by qualified individuals.</span></div>'
    : '';

  var infoEl = document.getElementById('pdp-info');
  if (infoEl) infoEl.innerHTML = ''
    + '<div class="eyebrow">' + p.cat + '</div>'
    + '<h1 class="pdp-t">' + p.name + '</h1>'
    + '<div class="pdp-sub">' + p.tagline + ' · Purity: <strong>' + p.purity + '</strong> · MW: ' + p.mw + '</div>'
    + '<div class="pdp-pr" id="pdp-pr">' + p.vars[0].p + ' kr</div>'
    + safetyNote
    + '<p class="pdp-desc">' + p.desc + '</p>'
    + (p.vars.length > 1 ? '<span class="opt-l">Select pack size</span><div class="swatches">' + swH + '</div>' : '')
    + '<div class="pdp-acts">'
    + '<div class="qty-ctrl"><button class="qb" onclick="chQ(-1)">−</button><span class="qn" id="pdp-qty">1</span><button class="qb" onclick="chQ(1)">+</button></div>'
    + '<button class="btn btn-dark pdp-atc" onclick="addCart(' + p.id + ',true)">Add to cart →</button>'
    + '</div>'
    + '<div style="background:rgba(46,107,94,.07);border:1px solid rgba(46,107,94,.16);border-radius:12px;padding:11px 15px;margin-bottom:14px">'
    + '<div style="font-size:.7rem;font-weight:600;color:#1F5247;margin-bottom:2px">Volume discount — save up to 15%</div>'
    + '<div style="font-size:.63rem;color:var(--muted)">Choose ×3 and save 10% · Choose ×5 and save 15% — price updates instantly</div>'
    + '</div>'
    + '<div style="display:flex;align-items:center;gap:8px;margin-bottom:20px;font-size:.68rem;color:var(--muted)">'
    + '<span>' + p.stars + '</span>'
    + '<span style="font-weight:600;color:var(--ink)">' + p.reviews + ' reviews</span>'
    + '<span>·</span>'
    + '<span style="color:#2E6B5E;font-weight:500">✓ Janoshik tested</span>'
    + '<span>·</span>'
    + '<span>Free shipping from 1,200 kr</span>'
    + '</div>'
    + '<div class="tabs">'
    + '<div class="tab on" onclick="selT(this,\'td\')">Description</div>'
    + '<div class="tab" onclick="selT(this,\'ti\')">Specification</div>'
    + '<div class="tab" onclick="selT(this,\'tu\')">Protocol</div>'
    + '</div>'
    + '<div class="tc on" id="td">' + p.desc + '</div>'
    + '<div class="tc" id="ti">' + ingH + '<div style="margin-top:14px;padding:12px 16px;background:var(--card3);border-radius:12px;font-size:.7rem;color:var(--muted);line-height:1.6"><strong style="color:var(--ink)">Amino acid sequence:</strong><br><span style="font-family:monospace;font-size:.65rem;word-break:break-all">' + p.seq + '</span></div></div>'
    + '<div class="tc" id="tu"><p style="font-size:.78rem;line-height:1.82;color:var(--muted)">' + p.use + '</p></div>';

  var pu = document.getElementById('pdp-upsell');
  if (pu) pu.innerHTML = (p.id !== BAC_ID) ? upsellBarHTML() : '';

  var rel = PRODS.filter(function(x) { return x.id !== id && x.cat === p.cat; }).slice(0,3);
  var relEl = document.getElementById('pdp-related');
  if (relEl) relEl.innerHTML = rel.length
    ? '<div class="prod-shell"><div class="prod-hdr"><div><div class="eyebrow">Related</div><h2 class="sec-title">You may also like</h2></div></div><div class="prod-grid g3">' + rel.map(prodCard).join('') + '</div></div>'
    : '';

  var pdpSection = document.getElementById('pdp-section');
  var shopSection = document.getElementById('shop-section');
  if (pdpSection) {
    if (shopSection) shopSection.style.display = 'none';
    pdpSection.style.display = '';
  }
  window.scrollTo(0,0);
}

function renderPdpGal(p, vi) {
  var galEl = document.getElementById('pdp-gal');
  if (!galEl) return;
  var badges = '<div style="position:absolute;bottom:18px;left:50%;transform:translateX(-50%);display:flex;gap:6px;align-items:center;white-space:nowrap">'
    + '<span style="background:rgba(46,107,94,.12);color:#2E6B5E;font-size:.58rem;font-weight:600;padding:5px 12px;border-radius:100px;letter-spacing:.1em">✓ JANOSHIK TESTED</span>'
    + '<span style="background:rgba(0,0,0,.06);font-size:.58rem;color:var(--muted);padding:5px 12px;border-radius:100px;letter-spacing:.1em">' + p.purity + ' PURITY</span>'
    + '</div>';
  if (p.imgs && p.imgs.length > 0) {
    var thumbsH = p.imgs.length > 1
      ? '<div id="pdp-thumbs-' + p.handle + '" style="display:flex;gap:8px;overflow-x:auto;padding:4px 0;margin-top:10px">'
        + p.imgs.map(function(src, i) {
          return '<div onclick="selGalImg(this,' + i + ',\'' + p.handle + '\')" style="cursor:pointer;border:2px solid '
            + (i===0?'var(--ink)':'var(--bd)') + ';border-radius:8px;overflow:hidden;width:54px;height:54px;flex-shrink:0">'
            + '<img src="' + src + '" style="width:100%;height:100%;object-fit:cover" loading="lazy"></div>';
        }).join('') + '</div>'
      : '';
    galEl.innerHTML = '<div style="display:flex;flex-direction:column;height:100%">'
      + '<div style="flex:1;background:var(--card2);border-radius:16px;overflow:hidden;position:relative;min-height:340px">'
      + '<img id="pdp-main-img" src="' + p.imgs[0] + '" style="position:absolute;inset:0;width:100%;height:100%;object-fit:cover">'
      + badges
      + '</div>' + thumbsH + '</div>';
  } else {
    galEl.innerHTML = '<div style="width:100%;height:100%;min-height:480px;border-radius:16px;background:var(--card2);display:flex;align-items:center;justify-content:center;position:relative">'
      + '<div style="position:absolute;top:15%;left:50%;transform:translateX(-50%);width:60%;height:60%;background:radial-gradient(ellipse,rgba(255,255,255,.5) 0%,transparent 70%);pointer-events:none"></div>'
      + '<div style="position:relative;z-index:1">' + vialSVG(p, 156, 312, vi) + '</div>'
      + badges + '</div>';
  }
}

function selGalImg(el, idx, handle) {
  var p = PRODS.find(function(x) { return x.handle === handle; });
  if (!p || !p.imgs || !p.imgs[idx]) return;
  var mainImg = document.getElementById('pdp-main-img');
  if (mainImg) mainImg.src = p.imgs[idx];
  var wrap = document.getElementById('pdp-thumbs-' + handle);
  if (wrap) wrap.querySelectorAll('div').forEach(function(d, i) {
    d.style.borderColor = i === idx ? 'var(--ink)' : 'var(--bd)';
  });
}

function selPV(el, vi) {
  pdpSel = vi;
  document.querySelectorAll('.sw').forEach(function(s) { s.classList.remove('on'); });
  el.classList.add('on');
  var v = curP.vars[vi];
  var discPcts = [0,10,15];
  var qtyMults = [1,3,5];
  var pct = discPcts[vi] || 0;
  var prEl = document.getElementById('pdp-pr');
  if (pct && vi > 0) {
    var orig = curP.vars[0].p * qtyMults[vi];
    prEl.innerHTML = fmtP(v.p)
      + ' <span style="font-size:.9rem;color:var(--muted);text-decoration:line-through;font-weight:400">' + fmtP(orig) + '</span> '
      + '<span style="font-size:.7rem;font-weight:600;color:#2E6B5E;background:rgba(46,107,94,.1);padding:3px 10px;border-radius:100px">−' + pct + '%</span>';
  } else {
    prEl.textContent = fmtP(v.p);
  }
  var sp = document.getElementById('sticky-atc-price');
  if (sp && curP) sp.textContent = fmtP(curP.vars[vi].p);
  renderPdpGal(curP, vi);
}

function selT(el, id) {
  document.querySelectorAll('.tab').forEach(function(t) { t.classList.remove('on'); });
  document.querySelectorAll('.tc').forEach(function(t) { t.classList.remove('on'); });
  el.classList.add('on');
  document.getElementById(id).classList.add('on');
}

function chQ(d) {
  pdpQty = Math.max(1, pdpQty + d);
  var el = document.getElementById('pdp-qty');
  if (el) el.textContent = pdpQty;
}

/* ══ CART ══════════════════════════════════════════════════ */
var CART_KEY = 'forma_cart';
var cart = [];

// Load cart from localStorage on startup
try {
  var _sc = localStorage.getItem(CART_KEY);
  if (_sc) {
    var _parsed = JSON.parse(_sc);
    // Re-hydrate: match each item back to full PRODS data
    cart = _parsed.map(function(c) {
      var p = PRODS.find(function(x) { return x.id === c.id; });
      if (!p) return null;
      return Object.assign({}, p, {qty: c.qty, v: p.vars[c.vi], vi: c.vi, key: c.key});
    }).filter(Boolean);
  }
} catch(e) { cart = []; }

function saveCart() {
  try {
    localStorage.setItem(CART_KEY, JSON.stringify(
      cart.map(function(c) { return {id: c.id, vi: c.vi, qty: c.qty, key: c.key}; })
    ));
  } catch(e) {}
}

function addCart(id, fromPdp) {
  var p = PRODS.find(function(x) { return x.id === id; });
  if (!p) return;
  var vi = fromPdp ? pdpSel : parseInt((document.getElementById('pc-'+id) || {dataset:{vi:'0'}}).dataset.vi || '0');
  var v = p.vars[vi];
  var qty = fromPdp ? pdpQty : 1;
  var key = id + '-' + vi;
  var ex = cart.find(function(c) { return c.key === key; });
  if (ex) ex.qty += qty;
  else cart.push(Object.assign({}, p, {qty: qty, v: v, vi: vi, key: key}));
  saveCart();
  updateCC();
  toast(p.name + ' added to cart');

  // Shopify AJAX cart sync (only when variant ID is configured)
  var variantId = v && v.vid ? v.vid : null;
  if (variantId) {
    fetch('/cart/add.js', {
      method: 'POST',
      headers: {'Content-Type': 'application/json'},
      body: JSON.stringify({id: variantId, quantity: qty})
    }).then(function(r) { return r.json(); }).catch(function(){});
  }
}

function updateCC() {
  var total = cart.reduce(function(s,c) { return s+c.qty; }, 0);
  var el = document.getElementById('cart-count');
  if (el) el.textContent = total;
  var cc = document.getElementById('cc');
  if (cc) cc.textContent = total;
}

function renderCart() {
  var b = document.getElementById('cart-body');
  if (!b) return;

  if (!cart.length) {
    b.innerHTML = '<div class="crt-empty"><p>Your cart is empty.</p><a href="/collections/alla" class="btn btn-dark">Browse peptides →</a></div>';
    return;
  }

  var sub = cart.reduce(function(s,c) { return s + c.v.p * c.qty; }, 0);
  var totalItems = cart.reduce(function(s,c) { return s + c.qty; }, 0);

  // ── Shipping ladder (two thresholds) ────────────────────────
  var T1 = 600, T2 = 1200;
  var barPct = Math.min(100, Math.round(sub / T2 * 100));
  var t1pct  = Math.round(T1 / T2 * 100);
  var need1  = Math.max(0, T1 - sub);
  var need2  = Math.max(0, T2 - sub);
  var shipMsg = sub >= T2
    ? 'Free tracked shipping is included in your order.'
    : (sub >= T1
      ? 'Add <strong>' + fmtP(need2) + '</strong> for tracked parcel · Letter post already included'
      : 'Add <strong>' + fmtP(need1) + '</strong> for letter post · <strong>' + fmtP(need2) + '</strong> for tracked parcel');

  var ck1 = sub >= T1; // letter unlocked
  var ck2 = sub >= T2; // tracked unlocked
  var ckSVG = '<svg width="12" height="12" viewBox="0 0 12 12" fill="none"><circle cx="6" cy="6" r="6" fill="var(--ink)"/><path d="M3.5 6l1.8 1.8L8.5 4" stroke="#fff" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  var ladderLabel = ck2 ? 'SHIPPING · FREE' : (ck1 ? 'SHIPPING · LETTER FREE' : 'SHIPPING');
  var ladderHTML = '<div class="crt-ladder">'
    + '<div class="crt-ladder-top"><span class="crt-ladder-lbl">' + ladderLabel + '</span><span class="crt-ladder-val">' + fmtP(sub) + ' / ' + fmtP(T2) + '</span></div>'
    + '<div class="crt-bar-wrap">'
    +   '<div class="crt-bar-fill" style="width:' + barPct + '%"></div>'
    +   '<div class="crt-bar-milestone" style="left:' + t1pct + '%">' + (ck1 ? ckSVG : '<div class="crt-bar-dot"></div>') + '</div>'
    +   '<div class="crt-bar-milestone" style="left:100%">'          + (ck2 ? ckSVG : '<div class="crt-bar-dot"></div>') + '</div>'
    + '</div>'
    + '<div class="crt-ladder-ticks"><span>' + fmtP(T1) + ' · letter</span><span>' + fmtP(T2) + ' · tracked parcel</span></div>'
    + '<div class="crt-ladder-msg">' + shipMsg + '</div>'
    + '</div>';

  // ── Cart items ───────────────────────────────────────────────
  var itemsHTML = cart.map(function(c) {
    var unitLabel = c.v.l.split('·')[0].trim();
    return '<div class="crt-item">'
      + '<div class="crt-item-img" style="background:var(--card2)">'
      + (c.imgs && c.imgs.length > 0
          ? '<img src="' + c.imgs[0] + '" alt="' + c.name + '" style="width:100%;height:100%;object-fit:cover;display:block">'
          : vialSVG(c, 30, 60, c.vi))
      + '</div>'
      + '<div class="crt-item-info">'
      + '<a class="crt-item-name" href="/products/' + c.handle + '">' + c.name + '</a>'
      + '<div class="crt-item-meta"><span class="crt-dot" style="background:' + c.bg + '"></span>' + c.cat + ' · ' + unitLabel + '</div>'
      + '</div>'
      + '<div class="crt-item-qty"><button class="crt-qb" onclick="updQ(\'' + c.key + '\',-1)">−</button><span class="crt-qn">0' + c.qty + '</span><button class="crt-qb" onclick="updQ(\'' + c.key + '\',1)">+</button></div>'
      + '<div class="crt-item-price">'
      + '<div class="crt-price-main">' + fmtP(c.v.p * c.qty) + '</div>'
      + '<div class="crt-price-sub">' + fmtP(c.v.p) + ' / ' + unitLabel.toLowerCase() + '</div>'
      + '</div>'
      + '<button class="crt-item-rm" onclick="remC(\'' + c.key + '\')">×</button>'
      + '</div>';
  }).join('');

  // ── Summary sidebar ──────────────────────────────────────────
  var summaryHTML = '<div class="crt-sum">'
    + '<div class="crt-sum-lbl">SUMMARY</div>'
    + '<div class="crt-sum-table">'
    + '<div class="crt-sum-row"><span>SUBTOTAL</span><span>' + fmtP(sub) + '</span></div>'
    + '<div class="crt-sum-row crt-sum-muted"><span>VAT</span><span>INCL. · 25%</span></div>'
    + '<div class="crt-sum-row crt-sum-muted"><span>SHIPPING</span><span>QUOTED AT ORDER</span></div>'
    + '<div class="crt-sum-row crt-sum-muted"><span>LEAD TIME</span><span>SHIPS WITHIN 24 H</span></div>'
    + '</div>'
    + '<div class="crt-sum-total"><span>ESTIMATED TOTAL</span><span class="crt-total-price">' + fmtP(sub) + '</span></div>'
    + '<button class="crt-checkout-btn" onclick="checkout()">CHECKOUT <span>→</span></button>'
    + '<div class="crt-legal">FOR LABORATORY RESEARCH ONLY — NOT FOR HUMAN CONSUMPTION. ORDERS DISPATCH FROM THE EU WITHIN 24 H, EU DELIVERY IN 48 H.</div>'
    + '</div>';

  // ── Recommendations ──────────────────────────────────────────
  var recProds = typeof PRODS !== 'undefined'
    ? PRODS.filter(function(p) { return p.id !== BAC_ID && !cart.find(function(c) { return c.id === p.id; }); }).slice(0, 3)
    : [];
  var recHTML = recProds.length
    ? '<div class="crt-rec">'
      + '<div class="crt-rec-top"><div><div class="crt-rec-eyebrow">ALSO OF INTEREST</div><div class="crt-rec-title">you might also <em>like.</em></div></div><a href="/collections/alla" class="crt-rec-link">FULL CATALOG →</a></div>'
      + '<div class="crt-rec-grid">'
      + recProds.map(function(p) {
          return '<div class="crt-rec-card">'
            + '<div class="crt-rec-img" style="background:' + p.bg + '">'
            + (p.imgs && p.imgs.length > 0
                ? '<img src="' + p.imgs[0] + '" alt="' + p.name + '" style="width:100%;height:100%;object-fit:contain;padding:4px">'
                : vialSVG(p, 24, 48, 0))
            + '</div>'
            + '<div class="crt-rec-info">'
            + '<div class="crt-rec-name">' + p.fullName.toLowerCase() + '</div>'
            + '<div class="crt-rec-meta"><span class="crt-dot" style="background:' + p.bg + '"></span>' + p.cat + ' · ' + p.vars[0].l.split('·')[0].trim().toLowerCase() + '</div>'
            + '<div class="crt-rec-price">' + fmtP(p.vars[0].p) + ' / ' + p.vars[0].l.split('·')[0].trim().toLowerCase() + '</div>'
            + '</div>'
            + '<button class="crt-rec-add" onclick="addCart(' + p.id + ',false)">+ ADD</button>'
            + '</div>';
        }).join('')
      + '</div></div>'
    : '';

  b.innerHTML = ladderHTML
    + '<div class="crt-body">'
    + '<div class="crt-items-col">'
    + '<div class="crt-items-head"><span class="crt-item-count">' + String(totalItems).padStart(2,'0') + ' ITEMS</span><button class="crt-clear-btn" onclick="clearCartAll()">clear cart</button></div>'
    + itemsHTML
    + '</div>'
    + summaryHTML
    + '</div>'
    + recHTML;
}

function clearCartAll() {
  cart = [];
  saveCart();
  updateCC();
  renderCart();
}

function updQ(key, d) {
  var c = cart.find(function(x) { return x.key === key; });
  if (!c) return;
  c.qty = Math.max(0, c.qty + d);
  if (!c.qty) cart = cart.filter(function(x) { return x.key !== key; });
  saveCart();
  updateCC();
  renderCart();
}

function remC(key) {
  cart = cart.filter(function(x) { return x.key !== key; });
  saveCart();
  updateCC();
  renderCart();
}

function checkout() {
  if (!cart.length) return;

  // Check if any variant IDs are configured (vid > 0)
  var hasVids = cart.some(function(c) { return c.v && c.v.vid && c.v.vid > 0; });

  if (!hasVids) {
    // Variant IDs not configured — show admin instructions
    var msg = document.getElementById('cart-vid-msg');
    if (!msg) {
      var sum = document.querySelector('.crt-sum');
      if (sum) {
        var div = document.createElement('div');
        div.id = 'cart-vid-msg';
        div.style.cssText = 'margin-top:12px;padding:14px 16px;background:#FEF3E2;border:1px solid #F59E0B;border-radius:12px;font-size:.72rem;line-height:1.7;color:#92400E';
        div.innerHTML = '<strong>Checkout not configured yet.</strong><br>'
          + 'You need to link the product Variant IDs in the theme code:<br><br>'
          + '1. Go to <strong>Shopify Admin → Products</strong><br>'
          + '2. Click a product → click a variant<br>'
          + '3. Copy the last number in the URL (e.g. <code style="background:rgba(0,0,0,.08);padding:1px 5px;border-radius:4px">…/variants/12345678901</code>)<br>'
          + '4. Go to <strong>Online Store → Themes → Edit code → snippets/shared-data.liquid</strong><br>'
          + '5. Replace <code style="background:rgba(0,0,0,.08);padding:1px 5px;border-radius:4px">vid:0</code> with the correct number for each variant';
        sum.appendChild(div);
        div.scrollIntoView({behavior:'smooth', block:'center'});
      }
    }
    return;
  }

  // All good — sync to Shopify cart and checkout
  var items = cart
    .filter(function(c) { return c.v && c.v.vid > 0; })
    .map(function(c) { return {id: c.v.vid, quantity: c.qty}; });

  var btn = document.querySelector('.crt-checkout-btn');
  if (btn) { btn.textContent = 'Processing…'; btn.disabled = true; }

  fetch('/cart/clear.js', {method:'POST'})
    .then(function() {
      return fetch('/cart/add.js', {
        method: 'POST',
        headers: {'Content-Type': 'application/json'},
        body: JSON.stringify({items: items})
      });
    })
    .then(function() {
      localStorage.removeItem(CART_KEY);
      window.location.href = '/checkout';
    })
    .catch(function() {
      if (btn) { btn.textContent = 'CHECKOUT →'; btn.disabled = false; }
      toast('Checkout error — please try again');
    });
}

/* ══ FILTER ════════════════════════════════════════════════ */
function filt(btn, f) {
  _currFilter = f;
  document.querySelectorAll('[data-f]').forEach(function(b) { b.classList.remove('on'); });
  if (btn) btn.classList.add('on');
  var list = f === 'all' ? PRODS : PRODS.filter(function(p) { return p.cat === f; });
  var sg = document.getElementById('shop-grid');
  if (sg) sg.innerHTML = list.map(prodCard).join('');
}

/* ══ ROUTINE ═══════════════════════════════════════════════ */
var curConcern = 'all';
function setConcern(btn, c) {
  document.querySelectorAll('[data-c]').forEach(function(b) { b.classList.remove('on'); });
  if (btn) btn.classList.add('on');
  curConcern = c;
  renderRoutine();
}
function renderRoutine() {
  var loc = _formaLocale;
  var phaseLabel = loc === 'sv' ? 'Fas' : 'Phase';
  var r = ROUTINES[curConcern] || ROUTINES.all;
  var stepsEl = document.getElementById('routine-steps');
  if (stepsEl) stepsEl.innerHTML = r.steps.map(function(s,i) {
    return '<div class="pstep">'
      + '<span class="s-idx">' + phaseLabel + ' 0' + (i+1) + '</span>'
      + '<div class="s-chip"><span class="sc-dot"></span><span class="sc-txt">' + s.c + '</span></div>'
      + '<h3 class="s-name">' + s.t + '</h3>'
      + '<p class="s-desc">' + s.d + '</p>'
      + '</div>';
  }).join('');
  var prods = r.prods.map(function(id) { return PRODS.find(function(p) { return p.id === id; }); }).filter(Boolean);
  var gridEl = document.getElementById('routine-grid');
  if (gridEl) gridEl.innerHTML = prods.map(prodCard).join('');
}

/* ══ TESTIMONIAL CAROUSEL ══════════════════════════════════ */
var REVIEWS = [
  {
    avatar:'ML', color:'#5A7A6A', stars:'★★★★★',
    quote:'RET+ GLP3 is the only peptide I keep coming back to. Forma\'s purity standard gives me a confidence that other suppliers simply cannot match. Delivery was fast and packaging impeccable.',
    name:'Marcus', title:'Verified customer · Biohacker & PT'
  },
  {
    avatar:'ES', color:'#4E6B7A', stars:'★★★★★',
    quote:'The Selank + Semax combination has become a fixed part of my study routine. Fast delivery, everything well packaged. The Janoshik test results give me full confidence in the quality.',
    name:'Erik', title:'Verified customer · Student & Biohacker'
  },
  {
    avatar:'JK', color:'#7A6A4E', stars:'★★★★☆',
    quote:'GHK-Cu at a reasonable price with actual analytical data behind it. I\'ve tried other suppliers — Forma operates at a completely different level. Highly recommended.',
    name:'Johan', title:'Verified customer · Longevity enthusiast'
  },
  {
    avatar:'AW', color:'#7A4E6A', stars:'★★★★★',
    quote:'The CJC+IPA blend is exactly what I was looking for. Simple ordering, fast delivery to Denmark and clear product information. Will definitely return.',
    name:'Anna', title:'Verified customer · Training & recovery'
  },
  {
    avatar:'DL', color:'#5A6A7A', stars:'★★★★☆',
    quote:'Not many suppliers include a full Janoshik report by default. Forma does. That alone sets them apart from most of the market. Second order now, no issues.',
    name:'David', title:'Verified customer · Research associate'
  },
  {
    avatar:'ZK', color:'#6A5A7A', stars:'★★★★★',
    quote:'Reliable, discreet, fast. Package arrived well-sealed with no markings. COA was accurate and matched what I expected. Will order again.',
    name:'Zeynep', title:'Verified customer · Independent researcher'
  }
];
var testiIdx = 0;
var testiTimer = null;

function renderTestiCarousel() {
  var wrap = document.getElementById('testi-inner');
  var dots = document.getElementById('testi-dots');
  if (!wrap || !dots) return;
  wrap.innerHTML = REVIEWS.map(function(r, i) {
    return '<div class="testi-slide' + (i===0?' active':'') + '" id="tslide-' + i + '">'
      + '<div class="testi-avatar" style="background:' + r.color + '">' + r.avatar + '</div>'
      + '<div class="t-stars">' + (r.stars || '★★★★★') + '</div>'
      + '<blockquote class="t-q">"' + r.quote + '"</blockquote>'
      + '<div class="t-a"><span class="t-name">' + r.name + '</span> <span class="t-title">' + r.title + '</span></div>'
      + '</div>';
  }).join('');
  dots.innerHTML = REVIEWS.map(function(_, i) {
    return '<div class="testi-dot' + (i===0?' active':'') + '" onclick="goTesti(' + i + ')"></div>';
  }).join('');
  clearInterval(testiTimer);
  testiTimer = setInterval(function() { goTesti((testiIdx + 1) % REVIEWS.length); }, 5500);
}

function goTesti(idx) {
  testiIdx = idx;
  document.querySelectorAll('.testi-slide').forEach(function(s, i) { s.classList.toggle('active', i === idx); });
  document.querySelectorAll('.testi-dot').forEach(function(d, i) { d.classList.toggle('active', i === idx); });
}

/* ══ NAV SEARCH ════════════════════════════════════════════ */
function navSearch(q) {
  var res = document.getElementById('nav-search-res');
  if (!res) return;
  if (!q || !q.trim()) { res.style.display = 'none'; return; }
  var lq = q.toLowerCase();
  var hits = PRODS.filter(function(p) {
    return p.name.toLowerCase().indexOf(lq) > -1
      || p.fullName.toLowerCase().indexOf(lq) > -1
      || p.cat.toLowerCase().indexOf(lq) > -1;
  }).slice(0, 5);
  if (!hits.length) { res.innerHTML = '<div class="nsr-item" style="color:var(--muted)">No results</div>'; res.style.display = 'block'; return; }
  res.innerHTML = hits.map(function(p) {
    return '<div class="nsr-item" onclick="window.location.href=\'/products/' + p.handle + '\'">'
      + '<span class="nsr-cat">' + p.cat + '</span>'
      + '<span>' + p.name + '</span>'
      + '<span class="nsr-price">' + p.vars[0].p + ' kr</span>'
      + '</div>';
  }).join('');
  res.style.display = 'block';
}

/* ══ FAQ ═══════════════════════════════════════════════════ */
function renderFAQ() {
  var loc = _formaLocale;
  var html = '', idx = 0;
  FAQS.forEach(function(section) {
    var cat = (loc === 'sv' && section.cat_sv) ? section.cat_sv : section.cat;
    html += '<div class="faq-cat">' + cat + '</div>';
    section.items.forEach(function(f) {
      var i = idx++;
      var q = (loc === 'sv' && f.q_sv) ? f.q_sv : f.q;
      var a = (loc === 'sv' && f.a_sv) ? f.a_sv : f.a;
      html += '<div class="faq-item"><div class="faq-q" onclick="togFaq(' + i + ')"><span>' + q + '</span><span class="faq-ico" id="fi' + i + '">+</span></div><div class="faq-a" id="fa' + i + '">' + a + '</div></div>';
    });
  });
  var el = document.getElementById('faq-list');
  if (el) el.innerHTML = html;
}
function togFaq(i) {
  var a = document.getElementById('fa'+i), ic = document.getElementById('fi'+i);
  var o = a.classList.contains('open');
  document.querySelectorAll('.faq-a').forEach(function(x) { x.classList.remove('open'); });
  document.querySelectorAll('.faq-ico').forEach(function(x) { x.classList.remove('open'); x.textContent = '+'; });
  if (!o) { a.classList.add('open'); ic.classList.add('open'); ic.textContent = '×'; }
}

/* ══ CONTACT & SUBSCRIBE ════════════════════════════════════ */
/* Formulären använder nu Shopify native form-taggar ({% form 'contact' %}
   och {% form 'customer' %}) och behöver ingen JavaScript. */
function submitContact() { /* deprecated — hanteras av Shopify */ }
function subscribe() { /* deprecated — hanteras av Shopify */ }

/* ══ TOAST ═════════════════════════════════════════════════ */
var tT;
function toast(m) {
  var t = document.getElementById('toast');
  if (!t) return;
  t.textContent = m;
  t.classList.add('show');
  clearTimeout(tT);
  tT = setTimeout(function() { t.classList.remove('show'); }, 2700);
}

/* ══ QUIZ ══════════════════════════════════════════════════ */
var quizStep = 0, quizAnswers = [];

function openQuiz() {
  quizStep = 0; quizAnswers = [];
  renderQuizStep();
  var ov = document.getElementById('quiz-overlay');
  if (ov) { ov.classList.add('open'); document.body.style.overflow = 'hidden'; }
}
function closeQuiz() {
  var ov = document.getElementById('quiz-overlay');
  if (ov) { ov.classList.remove('open'); document.body.style.overflow = ''; }
}
function renderQuizStep() {
  var total = QUIZ_QUESTIONS.length;
  var q = QUIZ_QUESTIONS[quizStep];
  var prog = document.getElementById('quiz-prog');
  var stepLabel = document.getElementById('quiz-step-label');
  var pctLabel = document.getElementById('quiz-pct-label');
  var pct = Math.round((quizStep / total) * 100);
  if (prog) prog.style.width = pct + '%';
  if (stepLabel) stepLabel.textContent = 'Question ' + (quizStep+1) + ' of ' + total;
  if (pctLabel) pctLabel.textContent = pct + '%';
  var content = document.getElementById('quiz-content');
  if (!content) return;
  content.innerHTML = '<div class="quiz-body">'
    + '<span class="quiz-q-label">Question ' + (quizStep+1) + ' of ' + total + '</span>'
    + '<div class="quiz-q-text">' + q.q + '</div>'
    + '<div class="quiz-opts">'
    + q.opts.map(function(o,i) {
      return '<button class="quiz-opt" onclick="quizSelect(' + i + ',\'' + o.val + '\')">'
        + '<span class="quiz-opt-icon">' + o.icon + '</span>'
        + o.label
        + '</button>';
    }).join('')
    + '</div>'
    + '<div class="quiz-nav">'
    + (quizStep > 0 ? '<button class="quiz-back" onclick="quizBack()">← Back</button>' : '<span></span>')
    + '<span style="font-size:.6rem;color:var(--muted);letter-spacing:.1em">' + (total - quizStep - 1) + ' questions remaining</span>'
    + '</div>'
    + '</div>';
}
function quizSelect(idx, val) {
  quizAnswers[quizStep] = val;
  if (quizStep < QUIZ_QUESTIONS.length - 1) {
    quizStep++;
    renderQuizStep();
  } else {
    showQuizResult();
  }
}
function quizBack() {
  if (quizStep > 0) { quizStep--; renderQuizStep(); }
}
function showQuizResult() {
  var prog = document.getElementById('quiz-prog');
  var pctLabel = document.getElementById('quiz-pct-label');
  if (prog) prog.style.width = '100%';
  if (pctLabel) pctLabel.textContent = '100%';

  var result = getQuizResult(quizAnswers);
  var prods = result.prods.map(function(id) { return PRODS.find(function(p) { return p.id === id; }); }).filter(Boolean);

  var content = document.getElementById('quiz-content');
  if (!content) return;
  content.innerHTML = '<div class="quiz-result">'
    + '<div style="font-size:1.8rem;margin-bottom:12px">🎯</div>'
    + '<h3>' + result.title + '</h3>'
    + '<p>' + result.desc + '</p>'
    + '<div class="quiz-rec-cards">'
    + prods.map(function(p) {
      return '<div class="quiz-rec" onclick="closeQuiz();window.location.href=\'/products/' + p.handle + '\'">'
        + '<div class="quiz-rec-vial">' + vialSVG(p, 40, 84, 0) + '</div>'
        + '<div class="quiz-rec-info">'
        + '<div class="quiz-rec-name">' + p.fullName + '</div>'
        + '<div class="quiz-rec-desc">' + p.tagline + ' · ' + p.purity + '</div>'
        + '</div>'
        + '<div class="quiz-rec-price">' + p.vars[0].p + ' kr</div>'
        + '</div>';
    }).join('')
    + '</div>'
    + '<a href="/collections/alla" class="btn btn-dark" style="width:100%;justify-content:center;display:flex" onclick="closeQuiz()">View all peptides →</a>'
    + '<button class="quiz-back" style="display:block;margin:12px auto 0;text-align:center" onclick="quizStep=0;quizAnswers=[];renderQuizStep()">← Retake quiz</button>'
    + '</div>';
}

/* ══ COUNTDOWN TIMER ═══════════════════════════════════════ */
(function() {
  var now = new Date();
  var target = new Date(now);
  target.setHours(23,59,59,0);
  function pad(n) { return String(n).padStart(2,'0'); }
  function tick() {
    var diff = target - new Date();
    if (diff <= 0) { target.setDate(target.getDate()+1); return; }
    var h = Math.floor(diff/3600000);
    var m = Math.floor((diff%3600000)/60000);
    var s = Math.floor((diff%60000)/1000);
    var th = document.getElementById('t-h'), tm = document.getElementById('t-m'), ts = document.getElementById('t-s');
    if (th) th.textContent = pad(h);
    if (tm) tm.textContent = pad(m);
    if (ts) ts.textContent = pad(s);
  }
  tick();
  setInterval(tick, 1000);
})();

/* ══ INIT ══════════════════════════════════════════════════ */
(function init() {
  // Country selector & language init
  initLang();

  // Sync cart badge from localStorage on every page load
  updateCC();

  // Render cart page if we're on /cart
  if (document.getElementById('cart-body')) {
    renderCart();
  }

  // Hero vials cluster — 3 products
  var hvials = document.getElementById('hero-vials');
  if (hvials) {
    var picks = [PRODS[0], PRODS[2], PRODS[4]].filter(Boolean);
    hvials.innerHTML = picks.map(function(p, i) {
      return '<div class="hv-item hv-i' + i + '">'
        + (p.imgs && p.imgs.length
            ? '<img src="' + p.imgs[0] + '" alt="' + p.name + '">'
            : vialSVG(p, 80, 160, 0))
        + '<div class="hv-label"><span class="hv-name">' + p.name + '</span><span class="hv-cat">' + p.cat + '</span></div>'
        + '</div>';
    }).join('');
  }

  // Mobile hero vial — real product photo of retatrutide
  var mobVial = document.getElementById('hero-mob-vial');
  if (mobVial && PRODS[0] && PRODS[0].imgs && PRODS[0].imgs[0]) {
    mobVial.innerHTML = '<img src="' + PRODS[0].imgs[0] + '" alt="' + PRODS[0].name + '" style="width:100%;height:100%;object-fit:contain;object-position:center bottom">';
  }

  // Hero2 fallback — show real product photos when no admin image is uploaded
  var h2fb = document.getElementById('hero2-fallback');
  if (h2fb) {
    var fbProds = [PRODS[0], PRODS[2], PRODS[5]].filter(function(p) { return p && p.imgs && p.imgs[0]; });
    if (fbProds.length > 0) {
      h2fb.style.cssText = 'width:100%;height:100%;display:flex;align-items:center;justify-content:center;gap:32px;background:linear-gradient(140deg,#EEEDE8 0%,#E8E7E2 100%);padding:40px 60px;box-sizing:border-box';
      h2fb.innerHTML = fbProds.map(function(p, i) {
        var sz = i === 0 ? '56%' : (i === 1 ? '44%' : '38%');
        var mt = i === 0 ? '0' : (i === 1 ? '-20px' : '20px');
        return '<img src="' + p.imgs[0] + '" alt="' + p.name + '" style="height:' + sz + ';max-height:320px;width:auto;object-fit:contain;margin-top:' + mt + ';filter:drop-shadow(0 24px 48px rgba(0,0,0,.15))">';
      }).join('');
    }
  }

  // Cluster vials (home editorial) — real product images
  var cv = document.getElementById('cluster-vials');
  if (cv) {
    var clProds = [PRODS[4], PRODS[2], PRODS[1]];
    var clH = [96, 118, 104];
    var clMT = [14, 0, 8];
    cv.innerHTML = clProds.map(function(p, i) {
      if (!p || !p.imgs || !p.imgs[0]) return '';
      return '<div class="vcl-img" style="height:' + clH[i] + 'px;margin-top:' + clMT[i] + 'px">'
        + '<img src="' + p.imgs[0] + '" alt="' + p.name + '">'
        + '</div>';
    }).join('');
  }

  // Home featured grid (first 3 products)
  var hg = document.getElementById('home-grid');
  if (hg) hg.innerHTML = PRODS.slice(0,3).map(prodCard).join('');

  // Shop grid (all products) — check for category shortcut from homepage
  var sg = document.getElementById('shop-grid');
  if (sg) {
    sg.innerHTML = PRODS.map(prodCard).join('');
    var cf = sessionStorage.getItem('catFilter');
    if (cf) {
      sessionStorage.removeItem('catFilter');
      var fb = document.querySelector('[data-f="' + cf + '"]');
      if (fb) filt(fb, cf);
    }
  }

  // Shop upsell bar
  var su = document.getElementById('shop-upsell');
  if (su) su.innerHTML = upsellBarHTML();

  // Add vol-badge to product images
  document.querySelectorAll('.prod-img').forEach(function(img) {
    if (!img.querySelector('.vol-badge')) {
      var b = document.createElement('div');
      b.className = 'vol-badge';
      b.textContent = '×3 −10% · ×5 −15%';
      img.appendChild(b);
    }
  });

  // Render dynamic sections
  renderTestiCarousel();
  renderFAQ();
  renderRoutine();
  renderPackages();

  // Cart page
  var cartBody = document.getElementById('cart-body');
  if (cartBody) renderCart();

  // Quiz overlay close on backdrop click
  var qo = document.getElementById('quiz-overlay');
  if (qo) qo.addEventListener('click', function(e) { if (e.target === this) closeQuiz(); });

  // Country overlay close listener (country modal has no backdrop-close — user must select)

  // Scroll reveal
  var rio = new IntersectionObserver(
    function(entries) { entries.forEach(function(e) { if (e.isIntersecting) e.target.classList.add('in'); }); },
    {threshold:0.07, rootMargin:'0px 0px -20px 0px'}
  );
  document.querySelectorAll('.reveal').forEach(function(el) { rio.observe(el); });

  // Email obfuscation — reconstruct from data attributes, never in raw HTML
  document.querySelectorAll('.email-obf').forEach(function(el) {
    var u = el.getAttribute('data-u');
    var d = el.getAttribute('data-d');
    if (!u || !d) return;
    var e = u + '@' + d;
    el.href = 'mailto:' + e;
    el.textContent = e;
  });
})();

/* ══ SECURITY ══════════════════════════════════════════════ */
(function() {
  // Console fingerprint warning
  var s = 'color:#c0392b;font-size:16px;font-weight:700;';
  console.log('%c⚠️  Stop.', s);
  console.log('%cThis console is for developers. If someone told you to paste something here, it is a social engineering attack.', 'font-size:13px;color:#555');

  // Block common DevTools keyboard shortcuts
  document.addEventListener('keydown', function(e) {
    var k = e.keyCode;
    // F12
    if (k === 123) { e.preventDefault(); return false; }
    // Ctrl/Cmd + U  (view-source)
    if ((e.ctrlKey || e.metaKey) && k === 85) { e.preventDefault(); return false; }
    // Ctrl/Cmd + Shift + I  (Inspector)
    if ((e.ctrlKey || e.metaKey) && e.shiftKey && k === 73) { e.preventDefault(); return false; }
    // Ctrl/Cmd + Shift + J  (Console)
    if ((e.ctrlKey || e.metaKey) && e.shiftKey && k === 74) { e.preventDefault(); return false; }
    // Ctrl/Cmd + Shift + C  (Element picker)
    if ((e.ctrlKey || e.metaKey) && e.shiftKey && k === 67) { e.preventDefault(); return false; }
  }, true);

  // Disable right-click context menu on images and product content only
  document.addEventListener('contextmenu', function(e) {
    var t = e.target;
    if (t.tagName === 'IMG' || t.closest('.prod-card') || t.closest('.pdp-info') || t.closest('.pdp-gal')) {
      e.preventDefault();
    }
  });
})();
